@if (loading()) {
	<nz-spin nzSimple nzSize="small"></nz-spin>
} @else {
	@if (user(); as user) {
		<nz-tag
			[nzColor]="BEFORE_AFTER_STATUS_UNCHANGED_COLOR"
			[nz-tooltip]="'The user is currently assigned in this many locations.'"
		>
			{{ existing() }}
		</nz-tag>
		<nz-tag
			[nzColor]="BEFORE_AFTER_STATUS_NEW_COLOR"
			[nz-tooltip]="'How many new locations will the user be assigned in.'"
		>
			{{ added() }}
		</nz-tag>
		<nz-tag
			[nzColor]="BEFORE_AFTER_STATUS_REMOVED_COLOR"
			[nz-tooltip]="'How many locations will be removed from the user.'"
		>
			{{ removed() }}
		</nz-tag>
		@if (enableEditButton()) {
			<button
				nz-button
				nzType="primary"
				nzSize="small"
				(click)="editUser(user)"
				nzShape="circle"
				nz-tooltip="Edit the user and locations"
			>
				<nz-icon nzType="edit" />
			</button>
		}
	}
}
